/*
 * a Collection of regions, each showing the survey labels for a single language
 */

define(["marionette", "./template/surveyLabelsTemplate.html"], function (
  Marionette,
  SurveyLabelsTemplate,
) {
  var SurveyLabelsView = {};

  SurveyLabelsView.surveyLabelsLayout = Marionette.Layout.extend({
    template: SurveyLabelsTemplate,
    regions: {
      touchPointSelect: "#touchPointSelect",
      surveyLabelDisplay: "#surveyLabelDisplay",
    },
  });

  return SurveyLabelsView;
});
